import { add, isBefore } from 'date-fns';
import { AccountDetails, ContractDetails } from '../../store/api-generated';
import { DAYS_BEFORE_ANNUAL_COLLECTION_DATE_THRESHOLD, MAX_BUDGET_BILL_AMOUNT } from '../../config/constants';

export default function checkCanAdjustAdvancePayment(
  account: AccountDetails,
  contract: ContractDetails,
) {
  const forbiddenStatuses = ['NEW', 'PEND', 'ENRL', 'FIN', 'TERM'];

  if (contract.status && forbiddenStatuses.includes(contract.status)) {
    return false;
  }

  if (account.budgetBillCounter != null && account.budgetBillCounter >= MAX_BUDGET_BILL_AMOUNT) {
    return false;
  }

  const annualCollectionDate = account?.financial?.annualCollectionDate && new Date(account.financial.annualCollectionDate);

  if (!annualCollectionDate) {
    return false;
  }

  const now = new Date();

  const threshold = add(now, {
    days: DAYS_BEFORE_ANNUAL_COLLECTION_DATE_THRESHOLD,
  });

  if (isBefore(annualCollectionDate, threshold)) {
    return false;
  }

  return true;
}
